import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({ spacing: { unit } }: ComposedTheme) => ({
  buttonsWrapper: {
    padding: [unit, 0]
  }
});

export default createUseStyles(styles);
